/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate, useLocation } from "react-router-dom";
import { empty, errorResponse, prepareResponseData } from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";

// css
import "../students/Students.css";

// api
import subjectApi from "../../api/Subject";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import { Toast } from "primereact/toast";
import FullPageLoader from "../../components/loader/FullPageLoader";
import TableLoading from "../../components/skeleton/TableLoading";
import ClassCategoryTable from "../../components/tables/primeTable/classes/ClassCategoryTable";
import { FaPlus } from "react-icons/fa";

const SubjectActivities = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  //ref
  const toastTR = useRef(null);
  // states
  const [subjectActivityData, setSubjectActivityData] = useState([]);
  const [subjectActivityModalVisibility, setSubjectActivityModalVisibility] = useState(false);
  const [selectedSubjectActivityDetail, setSelectedSubjectActivityDetail] =
    useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [modalType, setModalType] = useState("update");

  useEffect(() => {
    // fetch subject activities
    try {
      getSubjectActivities();

      if (!empty(location) && !empty(location.state)) {
        const paramState = !empty(location.state) ? location.state : {};
        let subjectActivityAdded = !empty(paramState.subjectActivityAdded)
          ? paramState.subjectActivityAdded
          : false;
        let subjectActivityUpdated = !empty(paramState.subjectActivityUpdated)
          ? paramState.subjectActivityUpdated
          : false;
        if (
          subjectActivityAdded === true ||
          subjectActivityUpdated === true 
        ) {
          const actionType = subjectActivityAdded
            ? "added"
            : subjectActivityUpdated
            ? "updated"
            : "";
          paramState.subjectActivityAdded = false;
          paramState.subjectActivityUpdated = false;
          responseDialog(
            "success",
            "Success",
            `Subject Activity ${actionType} successfully!`
          );
          if (!empty(location) && !empty(location.state)) {
            navigate(null, {
              replace: true,
              state: {
                subjectActivityAdded: false,
                subjectActivityUpdated: false,
              },
            });
          }
        }
      }
    } catch (error) {
      responseDialog(
        "error",
        "Something went wrong",
        "Failed to load classes. Please try again later."
      );
    }
  }, []);

  // function to get all classes
  const getSubjectActivities = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await subjectApi.getSubjectActivities(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setSubjectActivityData([]);
      } else {
        setSubjectActivityData(response_data.response);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  // delete subject activity
  const deleteSubjectActivity = async () => {
    try {
      if (subjectActivityModalVisibility) setSubjectActivityModalVisibility(false);
      if (!isActionLoading) setIsActionLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const subjectActivityId =
        !empty(selectedSubjectActivityDetail) &&
        !empty(selectedSubjectActivityDetail._id)
          ? selectedSubjectActivityDetail._id
          : "";
      const response = await subjectApi.deleteSubjectActivity(subjectActivityId, schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        const error_response =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Failed to delete class";
        return responseDialog("error", "Something went wrong", error_response);
      }

      responseDialog(
        "success",
        "Success",
        `Class, ${
          !empty(selectedSubjectActivityDetail.title)
            ? selectedSubjectActivityDetail.title
            : ""
        }, was deleted successfully!`
      );
      return getSubjectActivities();
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActionLoading(false);
    }
  };

  //function to hide confirm modal
  const hideClassModal = () => {
    setSubjectActivityModalVisibility(false);
  };

  //go to update subject activity page
  const gotToUpdateSubjectActivity = (data) => {
    const subjectActivityId = !empty(data) && !empty(data._id) ? data._id : "";
    navigate(`/subject-activity/${subjectActivityId}/update`);
  };

  // delete subject activity
  const showDeleteSubjectActivityModal = (data) => {
    setModalType("delete");
    setSelectedSubjectActivityDetail(data);
    setSubjectActivityModalVisibility(true);
  };

  const classModalFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: "#e65061",
          borderColor: "#e65061",
          borderWidth: 1,
        }}
        onClick={hideClassModal}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: "#389d17",
          borderColor: "#389d17",
          borderWidth: 1,
        }}
        onClick={() => deleteSubjectActivity()
        }
      />
    </div>
  );

  return (
    <>
      <AppWrapper {...props}>
        <main>
          <div className="tableCard">
            {/*  header start */}
            <MainHeader
              button
              buttonText="Add Subject Activity"
              link="/subject-activity/add"
              title="Subject Activities"
              icon={<FaPlus />}
              iconMarginRight={5}
            />
            {/* end of header */}

            {/* table start */}
            {!isLoading ? (
              <ClassCategoryTable
                classes={subjectActivityData}
                goToUpdateClassCategoryScreen={gotToUpdateSubjectActivity}
                goToDeleteClassCategoryScreen={showDeleteSubjectActivityModal}
              />
            ) : (
              <TableLoading rows={20} cols={3} header={false} />
            )}
            {/* table end  */}
          </div>
        </main>
        {isActionLoading && <FullPageLoader visible={isActionLoading} />}
      </AppWrapper>

      <Dialog
        visible={subjectActivityModalVisibility}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={classModalFooter}
        onHide={hideClassModal}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: "#e65061" }}
          />
          {
            <span>
              Are you sure you want to{" "}
              {modalType === "update" ? (
                !empty(selectedSubjectActivityDetail) &&
                !empty(selectedSubjectActivityDetail.active) &&
                selectedSubjectActivityDetail.active ? (
                  <span style={{ color: "red" }}>
                    <strong>disable</strong>
                  </span>
                ) : (
                  <span style={{ color: "green" }}>
                    <strong>enable</strong>
                  </span>
                )
              ) : (
                <span style={{ color: "red" }}>
                  <strong>delete</strong>
                </span>
              )}{" "}
              the selected subject activity -{" "}
              <strong>
                {!empty(selectedSubjectActivityDetail) &&
                !empty(selectedSubjectActivityDetail.title)
                  ? selectedSubjectActivityDetail.title
                  : ""}
              </strong>
              {selectedSubjectActivityDetail && (
                <b>
                  {!empty(selectedSubjectActivityDetail.name)
                    ? selectedSubjectActivityDetail.name
                    : ""}
                </b>
              )}
              ?
            </span>
          }
        </div>
      </Dialog>
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default SubjectActivities;
